/** Тип модуля. */
export enum ModuleType {
    /** Стандартный модуль. */
    Standart = "standart",
}
